import { staticContentAxios } from '../../configuration/axiosConfig';
import { ClientResponse } from '../../../model/ClientResponse';
import { DataResponseWithHistoriaFlag } from '../../../model/static/DataResponseWithHistoriaFlag';

// eslint-disable-next-line import/prefer-default-export
export const getChronologickyRegisterZakonovHistoriaHtmlContent = async (
  year: string | undefined,
  number: string | undefined,
)
  : Promise<ClientResponse<DataResponseWithHistoriaFlag>> => {
  const {
    data,
    status,
  } = await staticContentAxios.get(
    `/static/SK/ZZ/${year}/${number}/index.portal`,
  );
  return {
    data: { response: data, historia: true },
    responseCode: status,
  };
};
